export const APP_MODE = {
    DEFAULT: 'default',
    NEURONEXT: 'neuronext',
} as const

export type AppMode = typeof APP_MODE[keyof typeof APP_MODE]

const MODE_BY_DOMAIN: Record<string, AppMode> = {
    'enter.neuronext.pl': APP_MODE.NEURONEXT,
    'auth-stable0.neuronext.pl': APP_MODE.NEURONEXT,
    'auth-stable1.neuronext.pl': APP_MODE.NEURONEXT,
    'auth-feat-bn-1799-nn-auth.banxe-site.dev0.banxe.sits.pro': APP_MODE.NEURONEXT, // remove after test
}

export function resolveAppMode(hostname?: string): AppMode {
    if (!hostname) return APP_MODE.DEFAULT

    if (MODE_BY_DOMAIN[hostname]) return MODE_BY_DOMAIN[hostname]

    if (hostname.endsWith('.neuronext.pl')) return APP_MODE.NEURONEXT

    return APP_MODE.DEFAULT
}
